import React, { useState, useImperativeHandle, forwardRef } from "react";
import TextField from "@mui/material/TextField";
import { isValidCNPJ } from "../../../../utils/functions";

export interface DocumentInputRef {
  hasError: () => string | boolean;
}

interface Props {
  document: string;
  onChange?: (doc: string) => void;
  size?: string;
}

/** Formata CNPJ bruto (14 dígitos) como "XX.XXX.XXX/XXXX-XX" */
function formatCNPJ(raw: string): string {
  const v = (raw ?? "").replace(/\D/g, "").substring(0, 14);
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.substring(0, 2)}.${v.substring(2)}`;
  if (v.length <= 8) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5)}`;
  if (v.length <= 12) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8)}`;
  return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8, 12)}-${v.substring(12)}`;
}

const DocumentField = forwardRef<DocumentInputRef, Props>(
  ({ document, onChange, size }, ref) => {
    const [error, setError] = useState<string | boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const numericValue = event.target.value.replace(/\D/g, "");
      if (onChange) {
        onChange(numericValue);
      }
    };

    const handleBlur = () => {
      const isValid = isValidCNPJ(document);
      if (!isValid) {
        setError("CNPJ Inválido");
      } else setError(false);
    };

    useImperativeHandle(ref, () => ({
      hasError: () => error,
    }));

    return (
      <TextField
        label="CNPJ"
        variant="outlined"
        fullWidth
        value={formatCNPJ(document)}
        onChange={handleChange}
        onBlur={handleBlur}
        error={!!error}
        helperText={error ? String(error) : ""}
        size={size as any ?? "medium"}
        slotProps={{ htmlInput: { maxLength: 18 } }}
      />
    );
  }
);

export default DocumentField;
